/**
 * menuMobile.js
 * Tout ce qui concerne le menu principal lorsque nous somme dans la version mobile
 */

// Import
import './menuMobile.scss';
import $ from 'jquery';

$(document).ready(function () {

    function isMobileView() {
        return window.innerWidth < 992;
    }

    // Ouverture / fermeture du menu via le bouton hamburger (contrôle manuel, sans Bootstrap dropdown)
    $('#mobileMenuTrigger').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $menu = $('#mobileMenu');
        if ($menu.is(':visible')) {
            $menu.stop(true, true).slideUp(200);
            $(this).attr('aria-expanded', 'false');
        } else {
            $menu.stop(true, true).slideDown(300);
            $(this).attr('aria-expanded', 'true');
        }
    });

    // Bouton "Fermer le menu"
    $('.menuMobile_button-fermer').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('#mobileMenu').stop(true, true).slideUp(200);
        $('#mobileMenuTrigger').attr('aria-expanded', 'false');
    });

    // Fermeture au clic à l'extérieur du menu
    $(document).on('click', function (e) {
        if (!$(e.target).closest('#mobileMenu, #mobileMenuTrigger').length) {
            var $menu = $('#mobileMenu');
            if ($menu.is(':visible')) {
                $menu.stop(true, true).slideUp(200);
                $('#mobileMenuTrigger').attr('aria-expanded', 'false');
            }
        }
    });

    // Sous-menus : menu mobile ET menu vertical desktop (#main-menu)
    // Pas de garde isMobileView() : les items d-lg-none sont masqués sur desktop
    // et #main-menu (d-none d-lg-block) est masqué sur mobile — pas de chevauchement.
    $('.menu li.menu-item-has-children > a').on('click', function (e) {
        e.preventDefault();

        var $thisLink = $(this);
        var $parentLi = $thisLink.parent();
        var $subMenu = $thisLink.next('ul');

        if ($parentLi.hasClass('active')) {
            $parentLi.removeClass('active');
            $thisLink.removeClass('active');
            $subMenu.stop(true, true).slideUp(200);
        } else {
            // Fermer les autres onglets ouverts au même niveau (accordéon)
            $parentLi.siblings('li.menu-item-has-children').each(function () {
                $(this).removeClass('active');
                $(this).children('a').removeClass('active');
                $(this).children('ul').stop(true, true).slideUp(200);
            });

            $parentLi.addClass('active');
            $thisLink.addClass('active');
            $subMenu.stop(true, true).slideDown(300);
        }
    });

    // ARIA + classes actives
    $('.menu li .sub-menu').attr('aria-label', 'Sous-menu');
    $('.menu li.current-menu-ancestor').addClass('active');
    $('.menu li.current-menu-ancestor>a').addClass('active');
    $('.menu li.current-menu-parent>a').addClass('active');
    $('.menu .menu-item-has-children>a').attr('aria-haspopup', 'true');
});